import { Component, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-social-notifications',
  templateUrl: './social-notifications.page.html',
  styleUrls: ['./social-notifications.page.scss'],
})
export class SocialNotificationsPage implements OnInit {

  constructor(public languageService: LanguagesService) { }

  ngOnInit() {
  }

  get getTextIUPageSocialNotification() {
    return this.languageService.textsIU.page_social_notification;
  }

}
